import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";

function ContactForm() {
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    setTimeout(() => {
      setShowPopup(false);
    }, 5000);
  }, [showPopup]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(formData);
    if (!formData.full_name || !formData.email || !formData.message) {
      alert("All fields are required");
      return;
    }
    setLoading(true);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("full_name", formData.full_name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("message", formData.message);
      const response = await axios.post(
        "/api/save_contact.php",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.status === 200) {
        navigate("/thankyou", {
          state: {
            message:
              "Thank you for connecting with us. Our team will be connecting you shortly.",
          },
        });
      }
      setFormData({
        full_name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      setPopupMessage(
        "An error while submitting the form. Please try again later"
      );
      setShowPopup(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`max-w-3xl lg:max-w-5xl relative ${
        location.pathname === "/contact_us"
          ? "px-4 sm:px-6 md:px-10 lg:px-16 xl:px-24"
          : "w-full"
      } mx-auto bg-white rounded-lg`}
    >
      {loading ? (
        <div className="min-h-[400px] w-full flex justify-center items-center">
          <ClipLoader color="#006b4f" size={35} speedMultiplier={1} />
        </div>
      ) : (
        <div>
          <h2 className="mb-4 lg:mb-3 text-xl sm:text-2xl font-semibold text-gray-800">
            Get in touch!
          </h2>
  
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Full Name Field*/}
            <div>
              <input
                id="full_name"
                type="text"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                placeholder="Full Name*"
                className="w-full h-12 px-4 border border-gray-300 rounded-md text-gray-700 focus:ring-2 focus:ring-[#006A4E] focus:outline-none"
                aria-label="Full name"
                aria-required="true"
                autoCorrect="true"
                required
              />
            </div>
  
            {/* Email Field*/}
            <div>
              <input
                id="email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email Address*"
                className="w-full h-12 px-4 border border-gray-300 rounded-md text-gray-700 focus:ring-2 focus:ring-[#006A4E] focus:outline-none"
                aria-label="Email"
                aria-required="true"
                autoCorrect="true"
                required
              />
            </div>
  
            {/* Message Field*/}
            <div>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message*"
                className={`w-full ${
                  location.pathname === "/contact_us"
                    ? "min-h-[100px] sm:min-h-[130px] lg:min-h-[145px]"
                    : "min-h-[100px] sm:min-h-[135px] lg:min-h-[165px]"
                } px-4 py-3 border border-gray-300 rounded-md resize-none text-gray-700 focus:ring-2 focus:ring-[#006A4E] focus:outline-none`}
                aria-label="Your message"
                aria-required="true"
                autoCorrect="true"
                required
                onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
              />
            </div>
  
            <button
              type="submit"
              className="w-full h-12 font-medium text-white bg-[#006A4E] rounded-md hover:bg-[#004f37] transition-colors"
            >
              Submit Form
            </button>
          </form>
          {showPopup && (
            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div className="fixed inset-0 bg-white bg-opacity-65 backdrop-filter backdrop-blur-md transition-opacity duration-300 ease-in-out"></div>
              <div className="bg-[#FF0000] font-inter text-white p-4 rounded-xl shadow-md transition-transform duration-300 ease-in-out transform">
                {popupMessage}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ContactForm;